import styled from "@emotion/styled";
import React from "react";
import { FC } from "react";

const Styled = styled.div`
  label: WithKeyboardPadding;
  width: 100%;
  height: 100%;
  padding-bottom: var(--keyboard-height, 0px);
`;

const WithKeyboardPadding: FC<{ children: React.ReactNode }> = ({
  children
}) => {
  return <Styled>{children}</Styled>;
};

export default WithKeyboardPadding;
